import {
  FETCH_ANALYTICS_REPORT_STARTED,
  FETCH_ANALYTICS_REPORT_SUCCEEDED,
  FETCH_ANALYTICS_REPORT_FAILED,
  START_DATE_CHANGED,
  END_DATE_CHANGED,
  SEARCH_ORGANIZATION_FAILED,
  SEARCH_ORGANIZATION_SUCCEEDED,
  SEARCH_ORGANIZATION_STARTED,
  CLEAR_SUGGESTED_ORGANIZATIONS,
  SELECT_ORGANIZATION,
  REPORT_NOT_FOUND,
  EXPORT_TO_EXCEL_STARTED,
  EXPORT_TO_EXCEL_SUCCEEDED,
  EXPORT_TO_EXCEL_FAILED,
} from '../action-types/analyticsReportActionTypes';

const initialState = {
  report: [],
  startDate: new Date('November 1, 2018 00:00:01'),
  endDate: new Date(),
  startDateFormatted: new Date('November 1, 2018 00:00:01').toLocaleDateString(
    'en-US'
  ),
  endDateFormatted: new Date().toLocaleDateString('en-US'),
  isLoading: false,
  error: null,
  selectedOrganization: null,
  autoSuggesting: false,
  searchTerm: '',
  suggestedOrganizations: [],
  reportNotFound: false,
};

const analyticsReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANALYTICS_REPORT_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_ANALYTICS_REPORT_SUCCEEDED: {
      return {
        ...state,
        report: action.report,
        isLoading: false,
        reportNotFound: action.report.length === 0,
      };
    }

    case FETCH_ANALYTICS_REPORT_FAILED: {
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    }

    case START_DATE_CHANGED: {
      return {
        ...state,
        startDate: action.startDate,
        startDateFormatted: action.startDate.toLocaleDateString('en-US'),
      };
    }
    case END_DATE_CHANGED: {
      return {
        ...state,
        endDate: action.endDate,
        endDateFormatted: action.endDate.toLocaleDateString('en-US'),
      };
    }

    case SEARCH_ORGANIZATION_STARTED: {
      return {
        ...state,
        autoSuggesting: true,
        searchTerm: action.searchTerm,
      };
    }

    case SEARCH_ORGANIZATION_SUCCEEDED: {
      return {
        ...state,
        autoSuggesting: false,
        suggestedOrganizations: action.suggestedOrganizations,
        reportNotFound: state.searchTerm === '',
      };
    }

    case SEARCH_ORGANIZATION_FAILED: {
      return {
        ...state,
        autoSuggesting: false,
        error: action.error,
      };
    }
    case CLEAR_SUGGESTED_ORGANIZATIONS: {
      return {
        ...initialState,
        reportNotFound: state.searchTerm !== '',
      };
    }
    case SELECT_ORGANIZATION: {
      return {
        ...state,
        selectedOrganization: action.selectedOrganization,
      };
    }
    case REPORT_NOT_FOUND: {
      return {
        ...state,
        isLoading: false,
        report: [],
        reportNotFound: true,
      };
    }

    case EXPORT_TO_EXCEL_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case EXPORT_TO_EXCEL_SUCCEEDED: {
      return {
        ...state,

        isLoading: false,
        reportNotFound: state.report.length === 0,
      };
    }

    case EXPORT_TO_EXCEL_FAILED: {
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default analyticsReportReducer;
